import { CruisesContract as API, definitions } from '@luxuryescapes/contract-svc-cruise';

import cruisesAPI from './CruisesApiService';

const resource = 'rate-groups';

export type RateGroup = definitions['RATE_GROUP'] & {
  termsAndCondition: string;
};
export type RateGroupParams = definitions['GET_RATE_GROUPS_QUERY'];
export type CreateRateGroupBody = definitions['CREATE_RATE_GROUP_BODY'];
export type UpdateRateGroupBody = definitions['UPDATE_RATE_GROUP_BY_ID_BODY'];

export type RateByGroup = {
  id: string;
  code: string;
  rateDescription: string | null;
  departureId: string | null;
  currentGroups: Array<{
    id: string;
    name: string;
  }>;
};

export type UngroupedRateDetails = {
  id: string;
  description: string | null;
  rateCodeRemarks: string | null;
  isNonRefundable: boolean | null;
  detailsFetchFailed: boolean;
  rateCodeDetails: string | null;
  rateCodeDetailsFetchFailed: boolean;
};

export type UngroupedRateWithDetails = RateByGroup & UngroupedRateDetails;

export type RateGroupRecommendation = {
  rateGroup: {
    id: string;
    name: string;
    isRefundable: boolean;
  } | null;
  rationale: string;
  confidence: 'High' | 'Medium' | 'Low';
};

export type RateGroupRecommendations = Array<{
  rateId: string;
  recommendation: RateGroupRecommendation;
}>;

const list = async (params: RateGroupParams): Promise<API.Response<Array<RateGroup>>> => {
  return await cruisesAPI.http.get({ resource, queryString: JSON.stringify(params) });
};

const getRatesByGroup = async (params: {
  vendorId: string;
  rateCodes: Array<string>;
}): Promise<API.Response<Array<RateByGroup>>> => {
  return await cruisesAPI.http.post({ resource: `${resource}/rates-by-group`, body: params });
};

const getUngroupedRateDetails = async (params: {
  vendorId: string;
  departureId: string;
  rateIds: Array<string>;
}): Promise<API.Response<Array<UngroupedRateDetails>>> => {
  return await cruisesAPI.http.post({ resource: `${resource}/ungrouped-rate-details`, body: params });
};

const getRateGroupRecommendations = async (params: {
  rates: Array<{
    rateId: string;
    description: string;
    rateCodeRemarks: string | null;
    isNonRefundable: boolean;
    rateCodeDetails: string | null;
  }>;
}): Promise<API.Response<RateGroupRecommendations>> => {
  return await cruisesAPI.http.post({ resource: `${resource}/recommendations`, body: params });
};

const create = async (body: CreateRateGroupBody): Promise<RateGroup> => {
  const response = await cruisesAPI.http.post<API.Response<RateGroup>>({
    resource,
    body,
  });

  return response.result;
};

const update = async (id: string, body: UpdateRateGroupBody): Promise<RateGroup> => {
  const response = await cruisesAPI.http.put<RateGroup>({
    resource: `${resource}/${id}`,
    body,
  });

  return response.result;
};

const deleteById = async (id: string): Promise<void> => {
  await cruisesAPI.http.delete({ resource: `${resource}/${id}` });
};

export default {
  list,
  getRatesByGroup,
  getUngroupedRateDetails,
  getRateGroupRecommendations,
  create,
  update,
  deleteById,
};
